import { POST } from "../../api/api";

async function loginAuth(param) {
  try {
    const res = await POST("event/auth/partnership/login", param);
    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export { loginAuth };
